import { createFileRoute } from '@tanstack/react-router';
import {
  legacyFindingsSearch,
  redirectToHealthReadiness,
} from '@/components/health-readiness/legacy-redirect';

/**
 * The old Health Check → Findings register (T-0224, T-0242): lands on the
 * Findings tab with the same severity / status / domain filters.
 */
export const Route = createFileRoute('/engagements/$engagementId/health/findings')({
  validateSearch: legacyFindingsSearch,
  beforeLoad: ({ params, search }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'findings', filters: search });
  },
});
